import { Outlet } from "react-router-dom";
import { Box, useTheme } from "@mui/material";

import { useAuth } from "../auth/AuthContext";
import { UserRole } from "../constants/userRoles.ts";
import { tokens } from "../theme/tokens";

import SidebarNav from "./Sidebar";
import Topbar from "./Topbar";

const Layout = () => {
  const { user, tenantBranding } = useAuth();

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const isTenantUser =
    user?.role === UserRole.TENANT_ADMIN ||
    user?.role === UserRole.TENANT_STAFF;

  const primary =
    isTenantUser && tenantBranding?.primaryColor
      ? tenantBranding.primaryColor
      : colors.scalpelTeal[400];

  const secondary =
    isTenantUser && tenantBranding?.secondaryColor
      ? tenantBranding.secondaryColor
      : colors.houndGold[400];

  return (
    <Box
      display="flex"
      width="100vw"
      height="100vh"
      overflow="hidden"
      sx={{
        "--tenant-primary": primary,
        "--tenant-secondary": secondary,
      }}
    >
      <SidebarNav />

      <Box flex="1" display="flex" flexDirection="column" overflow="hidden">
        <Topbar />

        <Box
          component="main"
          flex="1"
          px={3}
          py={2}
          overflow="auto"
          boxSizing="border-box"
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;